// extracted by mini-css-extract-plugin
export default {"communityCards":"Communities_communityCards__SVOUS","communityCard":"Communities_communityCard__OyH0e","fadeInDownMenu":"Communities_fadeInDownMenu__28xGP"};